<template>
  <div class="header">
    <img
      src="../assets/image/logo2.png"
      alt=""
      class="logo"
      @click="goIndex"
    />

    <div class="content">
      <div
        :class="
          'item item' + item + (activeIndex == item ? ' active' + item : '')
        "
        v-for="(item, index) in [1, 2, 3, 4, 5]"
        :key="index"
        @click="clickNav(item)"
      ></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["activeIndex"])
  },
  methods: {
    goIndex() {
      this.$router.push({
        path: "/index",
        name: "Index"
      });
    },
    clickNav(num) {
      if (this.$route.path == "/index") {
        this.$store.dispatch("setActive", num);
      } else {
        this.$router.push({
          path: "/index",
          name: "Index",
          params: { activeIndex: num }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  z-index: 9999;
  width: 100%;
  min-width: 1200px;
  position: fixed;
  height: 8.54vw;
  background-image: url("../assets/image/header-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  .content {
    margin-left: 42.4%;
    height: 70%;
  }
  .logo {
    float: left;
    width: 7vw;
    height: 7vw;
    margin:  1vw 0 0 3vw;
    cursor: pointer;
  }
  .item {
    cursor: pointer;
    display: inline-block;
    width: 11vw;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 84% auto;
    background-position: 80% 50%;
  }
  .active1,
  .active2,
  .active3,
  .active4,
  .active5 {
    background-size: 84% auto;
    background-position: 80% 50%;
  }
  .item1 {
    background-image: url("../assets/image/nav1.png");
  }
  .item.active1 {
    background-image: url("../assets/image/nav1-act.png");
  }
  .item2 {
    background-image: url("../assets/image/nav2.png");
  }
  .item.active2 {
    background-image: url("../assets/image/nav2-act.png");
  }
  .item3 {
    background-image: url("../assets/image/nav3.png");
  }
  .item.active3 {
    background-image: url("../assets/image/nav3-act.png");
  }
  .item4 {
    background-image: url("../assets/image/nav4.png");
  }
  .item.active4 {
    background-image: url("../assets/image/nav4-act.png");
  }
  .item5 {
    background-image: url("../assets/image/nav5.png");
  }
  .item.active5 {
    background-image: url("../assets/image/nav5-act.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/page/header.vue